import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCustomerBackOrdersExcelThunk,
  fetchCustomerBackOrdersThunk,
} from "../thunks/customerBackOrderThunk";

const initialState = {
  data: [],
  backOrderExcel: [],
  loading: false,
  error: null,
};

const customerBackOrderSlice = createSlice({
  name: "customerBackOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerBackOrdersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerBackOrdersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCustomerBackOrdersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCustomerBackOrdersExcelThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerBackOrdersExcelThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.backOrderExcel = action.payload;
      })
      .addCase(fetchCustomerBackOrdersExcelThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default customerBackOrderSlice.reducer;
